<h1 class="title">Översikt larmkriterier</h1>
@if (hasEditRights) {
  <a [routerLink]="['/nytt-larm-kriterium']" class="section-spacer-bottom" style="display: inline-block;">
    <button type="button" class="btn btn-primary mt-3"><i class="fas fa-plus"></i> Lägg till larmkriterium </button>
  </a>
}
<app-table [config]="tableConfig" [expandedRows]="expanded" [rowsPerPage]="100"></app-table>
